import { gsap } from 'gsap';
import WebFont from 'webfontloader';

const hide = elem => {
    gsap.set(elem, { autoAlpha: 0 });
};

const preloadFonts = families => {
    return new Promise(resolve => {
        WebFont.load({
            google: {
                families: [...families],
            },
            active: resolve,
        });
    });
};

const animateFrom = (elem, direction, delay) => {
    direction = direction || 1;
    let x = 0,
        y = direction * 100;
    if (elem.classList.contains('gs_reveal_fromLeft')) {
        x = -100;
        y = 0;
    } else if (elem.classList.contains('gs_reveal_fromRight')) {
        x = 100;
        y = 0;
    }
    elem.style.transform = 'translate(' + x + 'px, ' + y + 'px)';
    elem.style.opacity = '0';
    gsap.fromTo(
        elem,
        { x: x, y: y, autoAlpha: 0, delay: delay },
        {
            duration: 1.25,
            x: 0,
            y: 0,
            autoAlpha: 1,
            ease: 'expo',
            overwrite: 'auto',
            delay: delay,
        }
    );
};

const getCookie = key => {
    if (!key) return null;

    return (
        decodeURIComponent(
            document.cookie.replace(
                new RegExp(
                    '(?:(?:^|.*;)\\s*' +
                        encodeURIComponent(key).replace(/[\-\.\+\*]/g, '\\$&') +
                        '\\s*\\=\\s*([^;]*).*$)|^.*$'
                ),
                '$1'
            )
        ) || null
    );
};

/**
 * @param {HTMLElement} container
 * @param {{ slidesPerView?: number, slidesPerGroup?: number, breakpoints?: Record<string, { slidesPerView?: number }> }} options
 */
const canEnableSwiperLoop = (container, { slidesPerView = 1, slidesPerGroup = 1, breakpoints = {} } = {}) => {
    const slideCount = container.querySelectorAll('.swiper-slide').length;

    if (slideCount <= 1) {
        return false;
    }

    let maxSlidesPerView = Number(slidesPerView);

    Object.values(breakpoints).forEach((breakpoint) => {
        if (breakpoint.slidesPerView !== undefined) {
            maxSlidesPerView = Math.max(maxSlidesPerView, Number(breakpoint.slidesPerView));
        }
    });

    return slideCount >= Math.ceil(maxSlidesPerView) + slidesPerGroup;
};

export { hide, preloadFonts, animateFrom, getCookie, canEnableSwiperLoop };
